import styled from "styled-components/macro";
import { editorTypographyStyles } from "../../TiptapDocumentSB/EditorContainer/editorContentStyles";

export const Container = styled.div`
  /* padding: 15px 25px; */
  /* padding-left: 25px; */
  justify-content: space-between;
  text-align: left;
  user-select: auto;
  display: flex;
  background: var(--menu-color);
  color: var(--grey-0);
  padding: 30px;
  flex-direction: column;
  position: relative;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;

  .header {
    display: flex;
    position: relative;
    align-items: flex-end;
    justify-content: space-between;
    flex-shrink: 0;
    margin-bottom: 20px;

    .headings {
      .main-heading {
        margin-bottom: 10px;
      }
      .sub-heading {
        margin-bottom: 10px;
        font-weight: 500;
      }

      .instruction {
        line-height: 1.3;
        font-weight: 500;
      }
    }

    .close {
      position: absolute;
      right: 0px;
      top: 0px;
      cursor: pointer;

      svg {
        stroke: var(--grey-0);
        fill: var(--grey-0);
      }
    }

    .header-buttons {
      .reset {
        margin-bottom: -10px;

        & > div {
          color: var(--primary-cta);
          svg {
            path {
              fill: var(--primary-cta);
            }
          }
        }
      }
    }
  }

  .content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  textarea.scrollable {
    color: var(--grey-0);
    background: var(--document-background);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-y: auto !important;
    font-size: 18px;
    padding: 1em;
    margin-bottom: 1em;
    line-height: 1.4em;
    font-family: "Inter";
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbar-track);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--scrollbar-thumb-hover);
    }

    &.wide {
      width: 800px;
    }

    &.medium {
      min-height: 200px;
    }

    &.short {
      min-height: 116px;
    }
    border: 1px solid var(--grey-2);
    border-radius: 10px;
    margin: 0 !important;
    overflow: hidden;
    resize: none;
    ::placeholder {
      color: var(--grey-1);
    }
  }

  .finished-style-preview {
    align-self: stretch;
    width: 100%;
    min-height: 0;
    max-height: 100%;
    overflow-y: auto;
    overscroll-behavior: contain;
    box-sizing: border-box;
    padding: 1em;
    border: 1px solid var(--grey-2);
    border-radius: 10px;
    background: var(--document-background);
    color: var(--grey-0);
    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    font-size: 18px;
    line-height: 1.4em;
    --sw-paragraph-spacing: 12px;
    ${editorTypographyStyles("&")}

    .tiptap,
    .ProseMirror {
      outline: none;
    }

    .ProseMirror > *:first-child {
      margin-top: 0;
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    margin-top: 20px;
  }

  .error {
    margin: 12px 0 0;
    color: var(--danger-color);
    font-size: 14px;
    font-weight: 500;
    line-height: 1.35;
  }

  .actions {
    display: flex;
    button,
    div {
      box-sizing: border-box;
      margin-top: 0;
      div {
        padding: 0;
      }
      &.main {
        font-size: 16px;
        background: var(--primary-cta);
        color: white;
        border: 0;
        border-radius: 10px;
        font-family: Inter;
        font-weight: 500;
        padding: 5px 15px;
        cursor: pointer;
        height: 41px;
        margin-left: 16px;

        &[disabled] {
          background: var(--grey-2);
          cursor: initial;
        }
      }

      &.secondary {
        font-size: 16px;
        background: var(--menu-color);
        color: var(--primary-cta);
        border: 2px solid var(--primary-cta);
        border-radius: 10px;
        font-family: Inter;
        font-weight: 500;
        padding: 5px 15px;
        cursor: pointer;
        height: 41px;

        &:hover {
          div {
            background-color: transparent;
          }
        }

        div {
          color: var(--primary-cta);

          svg {
            path {
              fill: var(--primary-cta);
            }
          }
        }
      }
    }
  }

  .typebot {
    text-align: center;

    svg {
      width: 40vh;
      height: auto;
      transform: translateX(-25px);
    }

    .word-scroll-box {
      font-size: 24px;
      color: var(--primary-cta-high-contrast);
      width: 100%;
      text-align: center;
      margin-top: 20px;
    }
  }

  .compressing {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .background {
      border-radius: 10px;
      background: var(--primary-cta);
      width: 100%;
      height: 100%;
      opacity: 0.1;
      &.shrinking {
        width: 50%;
        height: 20%;
        opacity: 0.1;
        transition: all 6s linear;
      }
    }

    .text {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 24px;
      color: var(--primary-cta);
      font-weight: 500;
    }
  }

  .count {
    opacity: 0.6;
    font-weight: 500;

    &.highlight-overage {
      font-weight: 500;
      color: red;
      opacity: 1;
    }
  }

  .intervention {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(55, 55, 55, 0.7);

    .modal {
      justify-content: space-between;
      text-align: left;
      background: white;
      user-select: auto;
      display: flex;
      background: var(--menu-color);
      color: var(--grey-0);
      padding: 30px;
      flex-direction: column;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 20px;

      .buttons {
        display: flex;
        justify-content: space-evenly;
      }

      .message {
        font-size: 16px;
        margin-bottom: 20px;
      }

      button.main {
        font-size: 16px;
        background: var(--primary-cta);
        color: white;
        border: 0;
        border-radius: 10px;
        font-family: Inter;
        font-weight: 500;
        padding: 5px 15px;
        cursor: pointer;
        height: 41px;
        margin-left: 16px;

        &[disabled] {
          background: var(--grey-2);
          cursor: initial;
        }
      }

      button.secondary {
        font-size: 16px;
        background: var(--menu-color);
        color: var(--primary-cta);
        border: 2px solid var(--primary-cta);
        border-radius: 10px;
        font-family: Inter;
        font-weight: 500;
        padding: 5px 15px;
        cursor: pointer;
        height: 41px;

        &:hover {
          div {
            background-color: transparent;
          }
        }

        div {
          color: var(--primary-cta);

          svg {
            path {
              fill: var(--primary-cta);
            }
          }
        }
      }
    }
  }
`;
